import {motion} from 'framer-motion';
import Card from "../shared/Card";
import { useContext } from "react";
import GeneralContext from "../../context/GeneralContext";
import ButtonFunction from '../shared/ButtonFunction';

function History() {

  const { changeUserMenu } = useContext(GeneralContext);

  return (
    <motion.div
      key='userHistory'
      initial={{opacity: 0, x: -1000}}
      animate={{opacity: 1, x: 0}}
      exit={{opacity: 0, x: -1000}}
      transition={{duration: 0.5}}>
      <Card>
        <h2>Historial de Solicitudes</h2>
        <ButtonFunction 
          buttonFunction={changeUserMenu}
          buttonArguments={'active-requests'}
          buttonClass='loginButton'
        >
          Solicitudes Activas
        </ButtonFunction>
        <br />
        <br />
        <ButtonFunction 
          buttonFunction={changeUserMenu}
          buttonArguments={'processed-requests'}
          buttonClass='loginButton'
        >
          Solcitudes Procesadas
        </ButtonFunction>
      </Card>
    </motion.div>
  )
}

export default History